// extracted by mini-css-extract-plugin
export default {"Container":"TitleAndDetail_Container__4cEko","Container_title":"TitleAndDetail_Container_title__gNCCz","Container_deatil":"TitleAndDetail_Container_deatil__Sznz9"};